import { createFileRoute } from "@tanstack/react-router";
import AgenciaSeoLocalCercaDeMi from "@/pages/AgenciaSeoLocalCercaDeMi";
import { buildBreadcrumb, ldJson } from "@/lib/site-schema";

const canonicalUrl = "https://agenciaseoevolution.com/agencia-seo-cerca-de-mi";

const breadcrumbSchema = buildBreadcrumb([{ name: "Agencia SEO cerca de mí", path: "/agencia-seo-cerca-de-mi" }]);

export const Route = createFileRoute("/agencia-seo-cerca-de-mi")({
  head: () => ({
    meta: [
      { title: "Agencia SEO Local Cerca de Mí | Expertos en Posicionamiento GEO" },
      {
        name: "description",
        content:
          "¿Buscas una agencia SEO Local cerca de mí? Encuentra la mejor agencia de posicionamiento GEO y SEO Local en tu zona. exclusividad por sector y zona garantizada.",
      },
      {
        name: "keywords",
        content: "agencia seo cerca de mi, seo local cerca, agencia posicionamiento local, consultoria seo mi zona",
      },
      { property: "og:type", content: "website" },
      { property: "og:url", content: canonicalUrl },
      { property: "og:title", content: "Agencia SEO Local Cerca de Mí | Expertos en Posicionamiento GEO" },
      {
        property: "og:description",
        content:
          "¿Buscas una agencia SEO Local cerca de mí? Encuentra la mejor agencia de posicionamiento GEO y SEO Local en tu zona. exclusividad por sector y zona garantizada.",
      },
      { name: "twitter:title", content: "Agencia SEO Local Cerca de Mí | Expertos en Posicionamiento GEO" },
      {
        name: "twitter:description",
        content:
          "¿Buscas una agencia SEO Local cerca de mí? Encuentra la mejor agencia de posicionamiento GEO y SEO Local en tu zona. exclusividad por sector y zona garantizada.",
      },
      { name: "geo.region", content: "ES" },
      { name: "geo.placename", content: "España" },
      { name: "geo.position", content: "40.4168;-3.7038" },
      { name: "ICBM", content: "40.4168, -3.7038" },
    ],
    links: [{ rel: "canonical", href: canonicalUrl }],
    scripts: [ldJson(breadcrumbSchema)],
  }),
  component: AgenciaSeoLocalCercaDeMi,
});
